import { Component, Input, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NativeIoService } from '../../../../../core/native/native-io.service';
import { BrandingService } from '../../../../../domain/service/brandingService';

@Component({
  selector: 'app-agreements',
  templateUrl: './agreements.component.html',
  styleUrl: './agreements.component.css'
})
export class AgreementsComponent {
 @Input() agreements!: FormGroup;
 readonly branding$ = inject(BrandingService).get();
 constructor(private readonly nativeIo: NativeIoService){}

 print(){
  this.nativeIo.openInternalRoute(['register/printLegalAgreement']);
 }
}
